module.exports = __webpack_public_path__ + "static/media/dianshang.422e6f19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/dianshang.svg
// module id = 36
// module chunks = 6